// header.liquid  アコーディオン
$(function() {
  function acordion() {
      $(this).next().slideToggle(300);
      $(this).toggleClass("open");
  }
  $(".header__accordion-btn").click(acordion);
});

